import React from 'react'


const Header = ({pageView}) => {
  return (
    <div className='bg-blue text-white font-semibold mt-2  px-2 py-1 rounded-sm shadow-md shadow-dark w-full' >
        <h1 className='text-xl'>MyKura</h1>
        <h2 className='text-md font-medium'>{pageView}</h2>
      </div>
  )
}

export default Header